import React, { useEffect, useState } from 'react'
import { Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../Master.css'

const ReportNavbar = () => {

  const selectedLanguage = sessionStorage.getItem('selectedLanguage');
  const [showStock, setShowStock] = useState(false);
  const [showBilling, setShowBilling] = useState(false);
  const [showPayment, setShowPayment] = useState(false);


    useEffect(() => {
        const handleScroll = () => {
          const navbar = document.querySelector(".navbar");
          if (window.scrollY > 100) {
            navbar.classList.add("fixed-top", "fixed-background");
          } else {
            navbar.classList.remove("fixed-top", "fixed-background");
          }
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

      const navDropdownStyle = {
        color: "rgb(47, 79, 79)"
      };

  return (
    <>
    <Row className='py-1 mt-3 mx-2 shadow m-0 p-0' style={{ display: "flex", backgroundColor: "rgb(47, 79, 79) ", borderRadius: "5px " }} >
                <Navbar expand="lg" className='p-0 m-0' style={{backgroundColor: "rgb(47, 79, 79) "}}>
                    <Container >
                        <Navbar.Brand style={{ color: "white", letterSpacing: "5px", borderBottom: "2px solid white" }}><b>{selectedLanguage === 'Marathi' ? 'अहवाल' : 'Report'}</b></Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto">

                            <Nav.Link href="/#/dashboardReport" className='text-light mx-2 '>{selectedLanguage === 'Marathi' ? 'डॅशबोर्ड' : 'Dashboard'}</Nav.Link>

                                <NavDropdown
                                    className='mx-2 dropdown-item-custom'
                                    title={<span style={{ color: "white" }}>{selectedLanguage === 'Marathi' ? 'साठा' : 'Stock'}</span>}
                                    id="basic-nav-dropdown"
                                    show={showStock}
                                    onMouseEnter={() => setShowStock(true)}
                                    onMouseLeave={() => setShowStock(false)}
                                >
                                    <NavDropdown.Item href="/#/deliveryStockReport">{selectedLanguage === 'Marathi' ? 'वितरण अहवाल' : 'Delivery Report'}</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/returnStockReport">{selectedLanguage === 'Marathi' ? 'अवितरित अहवाल' : 'Undelivery Report'}</NavDropdown.Item>
                                </NavDropdown>

                                <NavDropdown
                                    className='mx-2 dropdown-item-custom'
                                    title={<span style={{ color: "white" }}>{selectedLanguage === 'Marathi' ? 'बिलिंग' : 'Billing'}</span>}
                                    id="basic-nav-dropdown"
                                    show={showBilling}
                                    onMouseEnter={() => setShowBilling(true)}
                                    onMouseLeave={() => setShowBilling(false)}
                                >
                                    <NavDropdown.Item href="/#/generateBillReport">{selectedLanguage === 'Marathi' ? 'बिल तयार केलेले' : 'Generated Bill'}</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/pendingBillReport">{selectedLanguage === 'Marathi' ? 'प्रलंबित बिल' : 'Pending Bill'}</NavDropdown.Item>
                                </NavDropdown>

                                <NavDropdown
                                    className='mx-2 dropdown-item-custom'
                                    title={<span style={{ color: "white" }}>{selectedLanguage === 'Marathi' ? 'पेमेंट' : 'Payment'}</span>}
                                    id="basic-nav-dropdown"
                                    show={showPayment}
                                    onMouseEnter={() => setShowPayment(true)}
                                    onMouseLeave={() => setShowPayment(false)}
                                >
                                    <NavDropdown.Item href="/#/paymentRecReport">{selectedLanguage === 'Marathi' ? 'पेमेंट प्राप्त' : 'Payment Receive'}</NavDropdown.Item>
                                    <NavDropdown.Item href="/#/paymentPenReport">{selectedLanguage === 'Marathi' ? 'देयक प्रलंबित' : 'Payment Pending'}</NavDropdown.Item>
                                </NavDropdown>

                                <Nav.Link href="/#/expenseReport" className='text-light mx-2 '>{selectedLanguage === 'Marathi' ? 'खर्च' : 'Expense'}</Nav.Link>

                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </Row>
    </>
  )
}

export default ReportNavbar
